<div class="grid grid-cols-12 md:mt-8 mb-40" [dir]="languageDirection">
  <div
    class="col-start-2 col-span-10 md:col-start-3 md:col-span-8 xl:col-start-2 xl:col-span-10 xxl:col-start-3 xxl:col-span-8"
  >
    <div>
      <!-- <div class="container flex flex-col items-center mx-auto px-5 h-screen lg:py-0"> -->
      @if (currentJob$ | async; as currentJob) {
        <div class="mt-10 grid grid-cols-1 items-center dark:text-white" [dir]="languageDirection">
          <h1 class="text-3xl font-bold text-center sm:ltr:text-left sm:rtl:text-right">{{ currentJob.attributes.title }}</h1>
          <br />
          <div class="flex flex-row w-full justify-center sm:justify-start">
            <img
              class="sm:w-80 h-40 p-4 rounded-xl border border-gray-300 dark:border-gray-700"
              [src]="currentJob.attributes.company_logo?.data?.attributes?.url"
              [alt]="currentJob.attributes.company_name"
            />
            <div class="hidden sm:flex flex-col gap-1 ">
              <p class="p-4">{{ currentJob.attributes.company_name }}</p>
              <div
                *ngFor="
                  let jobCategory of currentJob.attributes.job_categories.data
                "
                class="flex justify-center text-center mx-2 border-[1px] border-gray-400 dark:border-gray-700 rounded-2xl"
              >
                <p class="px-3 py-1 text-xs">{{ jobCategory.attributes.category }}</p>
              </div>
            </div>
          </div>
          <div class="flex flex-col">
            <div class="flex flex-row flex-wrap items-center justify-center sm:justify-start py-2 text-xs">
              <div
                id="location"
                class="flex text-sm  ltr:pr-4 rtl:pl-4 items-center"
              >
                <ng-icon
                  name="bootstrapGeoAltFill"
                  class="ltr:mr-2 rtl:ml-2"
                ></ng-icon>
                {{ currentJob.attributes.location }}
              </div>

              <div
                id="startDate"
                class="flex text-sm  ltr:pr-4 rtl:pl-4 items-center"
              >
                <ng-icon
                  name="bootstrapBriefcase"
                  class="ltr:mr-2 rtl:ml-2"
                ></ng-icon>
                {{ currentJob.attributes.hiring_date }}
              </div>

              <div
                  id="requiredLanguage"
                  class="flex text-sm  ltr:pr-4 rtl:pl-4 items-center">
                <ng-icon
                  name="bootstrapGlobe2"
                  class="ltr:mr-2 rtl:ml-2"
                ></ng-icon>
                {{ currentJob.attributes.required_languages }}
              </div>
            </div>
            @if(currentJob.attributes.income_range){
              <div class="flex flex-row flex-wrap items-center justify-center sm:justify-start text-xs">
                <div id="incomeRange" class="w-fit flex text-sm  items-center">
                  <ng-icon
                    name="heroBanknotes"
                    class="ltr:mr-2 rtl:ml-2"
                  ></ng-icon>
                  <div>
                    {{ currentJob.attributes.income_range }}
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="flex flex-col gap-12 mt-12">
            <div>
              <h1 class="text-xl font-bold my-3 text-center sm:ltr:text-left sm:rtl:text-right">
                {{ 'JOB.YOUR-TASKS' | translate }}
              </h1>
              <div
                id="youTasks"
                [innerHTML]="currentJob.attributes.your_tasks | safeHtml"
              ></div>
            </div>
            <div>
              <h1 class="text-xl font-bold my-3 text-center sm:ltr:text-left sm:rtl:text-right">
                {{ 'JOB.QUALIFICATIONS' | translate }}
              </h1>
              <div
                [innerHTML]="currentJob.attributes.qualification | safeHtml"
              ></div>
            </div>
            <div>
              <h1 class="text-xl font-bold my-3 text-center sm:ltr:text-left sm:rtl:text-right">
                {{ 'JOB.BENEFITS' | translate }}
              </h1>
              <div [innerHTML]="currentJob.attributes.benefits | safeHtml"></div>
            </div>
            <div class="flex flex-col sm:flex-row my-4">
              <div class="h-64 w-full sm:w-80 md:w-96 lg:w-2/3 rounded-lg z-10">
                <app-map
                  [latitude]="currentJob.attributes.latitude"
                  [longitute]="currentJob.attributes.longitute"
                  class="rounded-lg"
                ></app-map>
              </div>
              <div class="flex flex-row rtl:flex-row-reverse justify-center sm:rtl:flex-col sm:ltr:flex-col gap-4 sm:gap-2 px-4 py-2 text-xs">
                <p>{{ currentJob.attributes.company_name }}</p>
                <div class="sm:whitespace-pre-line">
                  {{currentJob.attributes.address}}
                </div>
                <a
                  class="hover:text-blue-500 underline"
                  [href]="currentJob.attributes.google_map"
                  target="_blank"
                  rel="noopener noreferrer"
                >Google Maps</a>
              </div>
            </div>
          </div>
          <button
            class="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            (click)="showLoginOrRegisterModal()"
          >
            {{ 'JOB.APPLY' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</div>

<div
  id="loginOrRegisterModal"
  #loginOrRegisterModal
  tabindex="-1"
  aria-hidden="true"
  [@animateMoadl]="animateState"
  class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
>
  <div class="p-4 w-full max-w-2xl max-h-full">
    <!-- Modal content -->
    <div class="flex flex-col gap-8 bg-white rounded-2xl shadow p-8 dark:bg-gray-700 dark:text-white">
      <!-- Modal header -->
      <div
        [dir]="languageDirection"
      >
        <h1 class="text-sm md:text-xl font-semibold">{{"JOB.MODAL.TITLE" | translate}}</h1>
      </div>
      <!-- Modal body -->
      <div [dir]="languageDirection">
        <div class="flex ltr:text-left rtl:text-right w-full">
          {{"JOB.MODAL.BODY" | translate}}
        </div>
      </div>
      <div
        class="flex items-center justify-end"
      >
        <button
          (click)="closeLoginOrRegisterModal()"
          type="button"
          class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 mr-2 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
        >
        {{"JOB.MODAL.CLOSE" | translate}}
        </button>
        <a
          type="button"
          class="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          href="/auth/login"
        >
        {{"JOB.MODAL.GO-TO-LOGIN" | translate}}
        </a>
      </div>
    </div>
  </div>
</div>
